import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Stack from '@totallymoney/ui/components/Stack'
import WaveDivider from '@totallymoney/ui/components/WaveDivider'
import theme from '@totallymoney/ui/theme'

const FaqSectionWrapper = ({ children }: { children: React.ReactNode }) => (
    <Box
        as="article"
        backgroundColor="grey10"
        px={['space30', 'space80']}
        py={['space20', 'space20', 'space40']}
        position="relative"
    >
        <Box
            position="absolute"
            top={['-space30', '-space30', '-space40']}
            left={0}
            width="100%"
        >
            <WaveDivider waveColor={theme.grey10} />
        </Box>

        <Box margin="0 auto" maxWidth="1200px">
            <Box mb="space30">
                <Heading variant="60">Frequently Asked Questions</Heading>
            </Box>

            <Stack space="space15">{children}</Stack>
        </Box>
    </Box>
)

export default FaqSectionWrapper
